export default "__VITE_ASSET__B$9qZJPq__"